function toggleClass(element, className, addClass) {
  if (addClass) {
    element.classList.add(className);
  } else {
    element.classList.remove(className);
  }
}

function removeSelectedBundleClass(className) {
  const selectedClass = document.querySelector(className);

  if (selectedClass) {
    selectedClass.classList.remove("selected-bundle");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const bundleButtons = document.querySelectorAll(".bundle-button");
  const productBundleWrapper = document.querySelectorAll(
    ".product-bundle-wrapper"
  );

  if (productBundleWrapper.length) {
    // Display first bundle by default
    const firstBundle = productBundleWrapper[0];
    toggleClass(firstBundle, "show-bundle", true);
  }

  bundleButtons.forEach((btn) => {
    const buttonTarget = btn.dataset.target;

    btn.addEventListener("click", (e) => {
      // Remove "selected-bundle" class
      removeSelectedBundleClass(".bundle-button.selected-bundle");
      // Add "selected-bundle" class to the clicked button
      toggleClass(btn, "selected-bundle", true);

      // Iterate through bundle wrapper: Subscriptions and One Time Purchase (otp)
      productBundleWrapper.forEach((bundleWrapper) => {
        const bundleTarget = bundleWrapper.dataset.target;

        // Compare if data-target is the same for button and bundle-wrapper
        // If so, add class "show-bundle", else remove this class
        toggleClass(
          bundleWrapper,
          "show-bundle",
          buttonTarget === bundleTarget
        );
      });
    });
  });

  const bundleItems = document.querySelectorAll(".bundle-item");

  const sellingPlanInput = document.getElementById("product-form-selling-plan");
  const quantitySelector = document.getElementById("quantity-selector");
  const quantityInput = quantitySelector?.querySelector(".qty");

  if (bundleItems.length) {
    // Select first item by default
    const firstItem = bundleItems[0];
    toggleClass(firstItem, "selected-bundle", true);

    // On load: Collect value from first item and set it to Quantity input
    // Quantity input is the one that handles number of values added to the Cart
    if(quantityInput) quantityInput.value = firstItem.dataset.quantity ?? "0";
    // Do the same for Selling plan (subscription)
    sellingPlanInput.value = firstItem.dataset.planId ?? "0";
  }

  if (!sellingPlanInput || !quantitySelector || !quantityInput) return;

  bundleItems.forEach((item) => {
    item.addEventListener("click", () => {
      // First remove class from all the items
      removeSelectedBundleClass(".bundle-item.selected-bundle");

      // Then add class to the clicked bundleItem
      toggleClass(item, "selected-bundle", true);

      // Get the plan id for subscription
      const planID = item.dataset.planId;

      sellingPlanInput.value = planID;

      // Set bundle quantity to quantity-selector input
      quantityInput.value = item.dataset.quantity ?? "0";
    });
  });
});
